<template>
  <router-view />
</template>

<script>
export default {
  name: 'OperationsAiPromptConfig',
};
</script>
